module.exports = __webpack_public_path__ + "img/reject.84ca7981.svg";